import React from 'react';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import LogoImage from '../assets/logo.png'; // Update path if needed

const Mission = () => {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true,
  });

  return (
    <MissionContainer>
      <div className="container">
        <MissionContent 
          ref={ref}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={inView ? { opacity: 1, scale: 1 } : { opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.5 }}
        >
          <LogoIconWrapper>
            <img src={LogoImage} alt="The Coach House Logo" />
          </LogoIconWrapper>
          <h2>Transforming lives through clarity, confidence and personal growth</h2>
        </MissionContent>
      </div>
    </MissionContainer>
  );
};

const MissionContainer = styled.section`
  background-color: #5A7F8C;
  padding: 60px 0;
  text-align: center;
`;

const MissionContent = styled(motion.div)`
  max-width: 800px;
  margin: 0 auto;
  
  h2 {
    color: white;
    font-size: 2rem;
    font-weight: 400;
    margin-top: 25px;
  }
`;

const LogoIconWrapper = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  padding: 15px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
  
  img {
    width: 130%;
    height: auto;
  }
`;

export default Mission;